document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-main-nav]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  document.querySelectorAll('[data-category-track]').forEach((track) => {
    const section = track.closest('.category-showcase');
    section?.querySelector('[data-category-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }));
    section?.querySelector('[data-category-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-category-track], [data-product-track], [data-watch-track]').forEach((track) => {
    if (track.hasAttribute('data-watch-track')) {
      track.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.loop = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        const playVideo = () => video.play().catch(() => {});
        video.addEventListener('canplay', playVideo, { once: true });
        if ('IntersectionObserver' in window) {
          const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) playVideo();
              else video.pause();
            });
          }, { threshold: 0.15 });
          videoObserver.observe(video);
        } else playVideo();
      });
    }
    const originals = Array.from(track.children);
    if (!originals.length) return;
    const first = originals[0];
    const last = originals[originals.length - 1];
    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
    const loopWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft + gap;
    if (!loopWidth) return;

    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';
    const copiesNeeded = Math.max(2, Math.ceil(track.clientWidth / loopWidth) + 1);
    for (let copy = 0; copy < copiesNeeded; copy += 1) {
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.style.pointerEvents = 'none';
        if (clone.matches('a, button, [tabindex]')) clone.setAttribute('tabindex', '-1');
        clone.querySelectorAll('a, button, [tabindex]').forEach((node) => node.setAttribute('tabindex', '-1'));
        track.appendChild(clone);
      });
    }

    let hovered = false;
    let focused = false;
    let pauseUntil = 0;
    let previousTime = 0;
    const pauseBriefly = () => { pauseUntil = performance.now() + 2500; };
    track.addEventListener('mouseenter', () => { hovered = true; });
    track.addEventListener('mouseleave', () => { hovered = false; });
    track.addEventListener('focusin', () => { focused = true; });
    track.addEventListener('focusout', (event) => { if (!track.contains(event.relatedTarget)) focused = false; });
    ['pointerdown', 'touchstart', 'wheel'].forEach((eventName) => track.addEventListener(eventName, pauseBriefly, { passive: true }));

    const speed = track.hasAttribute('data-product-track') ? 30 : track.hasAttribute('data-watch-track') ? 26 : 20;
    const animate = (time) => {
      if (document.visibilityState === 'visible' && !hovered && !focused && time > pauseUntil) {
        if (previousTime) track.scrollLeft += ((time - previousTime) * speed) / 1000;
        if (track.scrollLeft >= loopWidth) track.scrollLeft %= loopWidth;
      }
      previousTime = time;
      requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  });

  document.querySelectorAll('[data-product-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      const image = gallery?.querySelector('[data-main-product-image]');
      if (!image || !button.dataset.fullSrc) return;
      image.src = button.dataset.fullSrc;
      image.alt = button.dataset.alt || '';
      gallery.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
        const active = thumb === button;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    });
  });

  document.querySelectorAll('[data-zoom-stage]').forEach((stage) => {
    const image = stage.querySelector('[data-main-product-image]');
    const gallery = stage.closest('[data-product-gallery]');
    const dialog = gallery?.querySelector('[data-product-zoom]');
    const zoomImage = dialog?.querySelector('[data-product-zoom-image]');
    const updateZoomImage = () => {
      if (image && zoomImage) {
        zoomImage.src = image.currentSrc || image.src;
        zoomImage.alt = image.alt;
      }
    };
    stage.addEventListener('pointermove', (event) => {
      if (event.pointerType === 'touch') return;
      const rect = stage.getBoundingClientRect();
      stage.style.setProperty('--zoom-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
      stage.style.setProperty('--zoom-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
      stage.classList.add('is-zoomed');
    });
    stage.addEventListener('pointerleave', () => stage.classList.remove('is-zoomed'));
    gallery?.querySelector('[data-open-product-zoom]')?.addEventListener('click', () => {
      updateZoomImage();
      dialog?.showModal();
    });
    dialog?.querySelector('[data-close-product-zoom]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const page = form.closest('[data-product-page]');
    const details = form.closest('.product-details');
    const picker = form.querySelector('[data-product-variants-picker]');
    const variantData = form.querySelector('[data-product-variants]');
    const hiddenVariant = form.querySelector('[data-selected-variant]');
    const productVariants = variantData ? JSON.parse(variantData.textContent) : [];
    const sticky = page?.querySelector('[data-sticky-product-cart]');
    const purchaseRow = form.querySelector('[data-product-purchase-row]');
    const optionGroups = picker ? Array.from(picker.querySelectorAll('[data-option-group]')).sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)) : [];

    const readOptions = () => optionGroups.map((group) => {
      const selectedButton = group.querySelector('.size-button.is-selected');
      const select = group.querySelector('[data-option-select]');
      return selectedButton ? selectedButton.dataset.optionValue : select?.value;
    });
    const updateVariant = () => {
      const values = readOptions();
      const sizeIndex = optionGroups.findIndex((group) => group.classList.contains('size-option-group'));
      const selectedSizeNode = page?.querySelector('[data-selected-size]');
      if (selectedSizeNode && sizeIndex >= 0) selectedSizeNode.textContent = values[sizeIndex] || '';
      optionGroups.forEach((group, index) => {
        const buttons = Array.from(group.querySelectorAll('[data-option-value]'));
        const select = group.querySelector('[data-option-select]');
        const controls = buttons.length ? buttons : Array.from(select?.options || []);
        controls.forEach((control) => {
          const value = buttons.length ? control.dataset.optionValue : control.value;
          const available = productVariants.some((variant) => variant.available && variant.options[index] === value && variant.options.every((option, otherIndex) => otherIndex === index || option === values[otherIndex]));
          control.disabled = !available;
        });
      });

      const variant = productVariants.find((item) => item.options.every((value, index) => value === values[index]));
      if (!variant) return;
      if (hiddenVariant) hiddenVariant.value = variant.id;
      const priceNode = details?.querySelector('[data-product-price]');
      const comparePriceNode = details?.querySelector('[data-compare-price]');
      const saleBadge = details?.querySelector('[data-sale-badge]');
      const skuNode = details?.querySelector('[data-product-sku]');
      const submitButton = details?.querySelector('[data-add-to-cart]');
      if (priceNode) priceNode.textContent = variant.price;
      if (comparePriceNode) {
        comparePriceNode.textContent = variant.comparePrice || '';
        comparePriceNode.hidden = !variant.comparePrice;
      }
      if (saleBadge) saleBadge.hidden = !variant.comparePrice;
      if (skuNode) skuNode.textContent = variant.sku ? `SKU: ${variant.sku}` : '';
      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      const stickyPrice = sticky?.querySelector('[data-sticky-product-price]');
      const stickyButton = sticky?.querySelector('[data-sticky-add-to-cart]');
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (variant.image) {
        const image = page?.querySelector('[data-main-product-image]');
        if (image) image.src = variant.image;
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (_) { /* Keep variant selection working if URL updates are unavailable. */ }
    };

    optionGroups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((choice) => {
            const selected = choice === button;
            choice.classList.toggle('is-selected', selected);
            choice.setAttribute('aria-pressed', String(selected));
          });
          updateVariant();
        });
      });
      group.querySelector('[data-option-select]')?.addEventListener('change', updateVariant);
    });
    if (optionGroups.length) updateVariant();

    form.querySelectorAll('[data-quantity-step]').forEach((stepButton) => {
      stepButton.addEventListener('click', () => {
        const quantity = form.querySelector('input[name="quantity"]');
        if (!quantity) return;
        const min = Number(quantity.min) || 1;
        const current = Number(quantity.value) || min;
        quantity.value = String(Math.max(min, current + Number(stepButton.dataset.quantityStep || 0)));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (sticky && purchaseRow) {
      const syncSticky = () => {
        const passed = purchaseRow.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', String(!passed));
      };
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }
  });
  document.querySelectorAll('[data-product-wishlist]').forEach((button) => {
    const key = `zauk-wishlist-${button.dataset.productWishlist}`;
    const render = (saved) => {
      button.setAttribute('aria-pressed', String(saved));
      button.textContent = saved ? '♥' : '♡';
      button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
    };
    try { render(window.localStorage.getItem(key) === '1'); } catch (_) { /* Wishlist works for this session even when storage is blocked. */ }
    button.addEventListener('click', () => {
      const saved = button.getAttribute('aria-pressed') !== 'true';
      render(saved);
      try { window.localStorage.setItem(key, saved ? '1' : '0'); } catch (_) { /* Ignore storage restrictions. */ }
    });
  });
  document.querySelectorAll('[data-share]').forEach((button) => {
    button.addEventListener('click', async () => {
      if (navigator.share) await navigator.share({ title: document.title, url: window.location.href });
      else if (navigator.clipboard) { await navigator.clipboard.writeText(window.location.href); button.textContent = 'Link copied'; }
    });
  });
});
